import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState, useCallback } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Check, Close, ExpandMore } from '@mui/icons-material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import FormEditData from './form';
import {
  EditDataControl,
  CommonInterfaceSubscription,
} from 'subscription/view-models/common-interface-subscription';

interface EditaDataProps {
  isCohabitation: boolean;
  isAire?: boolean;
  disabledFromAct?: boolean;
}

const EditDataComponent = ({
  isCohabitation,
  isAire,
  disabledFromAct,
}: EditaDataProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CommonInterfaceSubscription>();

  const onFieldEditDataChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('editDataControl', {
        ...formContext.values.editDataControl,
        [key]: value,
      });
    },
    [formContext.values.editDataControl, formContext.setFieldValue]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-edit-data-control-content"
        id="panel-person-edit-data-control-header"
        expandIcon={<ExpandMore />}
      >
        {formContext.errors.editDataControl ? <Close color="error" /> : <Check color="success" />}
        <Typography>{isAire ? 'Dati di controllo' : 'Dati di controllo modifica'}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <FormEditData
          isCohabitation={isCohabitation}
          values={formContext.values.editDataControl}
          onChange={onFieldEditDataChange}
          errors={formContext.errors.editDataControl as FormikErrors<EditDataControl>}
          touched={formContext.touched.editDataControl as unknown as FormikTouched<EditDataControl>}
          isAire={isAire}
          disabledFromAct={disabledFromAct}
        />
      </AccordionDetails>
    </Accordion>
  );
};

EditDataComponent.displayName = 'Accordion Other Citizenship component';

const EditData = memo(EditDataComponent);

export default EditData;
